import {
  isMobile,
  trackMoengageEvent,
} from "../../../utils/commonMethods";
import {Network} from "../../../utils/network";
import {
  CFDropCheckoutPayment,
  CFEnvironment,
  CFSession,
  CFThemeBuilder,
} from "cashfree-pg-api-contract";
import {walletImport} from "../walletImports";
import Colors from "../../../assets/Color/Colors";
import {globalImport} from "../../../common/globalImports";
import {REACT_APP_ENV} from "../../../../index";
import {store} from "../../../store/store";
import {hideLoader} from "../../../commonComponents/Loader/loader.actions";

export const cashfreeRecharge = (res, amount) => {
  //alert(1);
  if (!globalImport.isWeb) {
    if (!res?.data?.error && res?.data?.payment_session_id) {
      try {
        const session = new CFSession(
          res?.data?.payment_session_id,
          res?.data?.order_id,
          REACT_APP_ENV === "prod"
            ? CFEnvironment.PRODUCTION
            : CFEnvironment.SANDBOX,
        );
        const theme = new CFThemeBuilder()
          .setNavigationBarBackgroundColor(Colors.tradexBlue)
          .setNavigationBarTextColor("#FFFFFF")
          .setButtonBackgroundColor("#FFC107")
          .setButtonTextColor("#FFFFFF")
          .setPrimaryTextColor("#212121")
          .setSecondaryTextColor("#757575")
          .build();

        const dropPayment = new CFDropCheckoutPayment(session, null, theme);
        walletImport.CFPaymentGatewayService.doPayment(dropPayment);
      } catch (e) {
        console.log(e.message);
      }
    }
  } else {
    const isProd =
      REACT_APP_ENV === "prod" || REACT_APP_ENV === "preprod" ? true : false;
    //let cashfree;
    const cashfree = Cashfree({
      mode: !isProd ? "sandbox" : "production", //or production
    });
    let checkoutOptions = {
      paymentSessionId: res?.data?.payment_session_id,
      returnUrl: window.location.href + `?myorder={order_id}&amt=${amount}`,
      redirectTarget: "_self",
    };
    cashfree.checkout(checkoutOptions).then(function (result) {
      if (result.error) {
      }
      if (result.redirect) {
        console.log("Redirection");
      }
    });
    //cashfree.redirect();
  }
};

//required userid,withdrawAmount
export async function successFunction(
  orderId,
  amount,
  navigation,
  userInfo,
  res,
  setEnableStatusScreen,
) {
  trackMoengageEvent("Deposit Status", {
    Status: "success",
    orderId: orderId,
    Timedeposit: new Date(),
    method: "cashfree",
    Amount: amount,
    title: orderId,
  });
  // trackAppsflyerEvent("recharge_success", {
  //   status: "success",
  //   orderId: "",
  //   datetime: new Date(),
  //   method: "",
  //   userId: userInfo?.userid,
  // });
  // trackAppsflyerEvent("recharge_amount", {
  //   status: "success",
  //   orderId: "",
  //   datetime: new Date(),
  //   af_revenue: amount,
  //   af_currency: "INR",
  // });
  var a = {
    isShow: true,
    status: res?.data?.success,
    amount: amount,
    msg: res ? res?.data?.message : "Added succesfully",
    title: res?.data?.title,
    isDeposit: true,
  };
  if (!globalImport.isWeb) {
    const cashfreeRes = {
      order: {
        orderId: orderId,
        status: "PAID",
      },
      transaction: {
        transactionAmount: amount,
      },
    };
    const res = await Network.addPayment(cashfreeRes);
    !globalImport.isWeb && store.dispatch(hideLoader(false));
  }

  if (!isMobile()) {
    setEnableStatusScreen({paymentStatus: a});
  } else {
    navigation.push("WalletStack", {
      screen: "WalletStatus",
      params: {paymentStatus: a},
    });
  }
  //Network.addPayment(orderId);
}

//required withdraw amount

export function failureFunctionWeb(amount, navigation, setEnableStatusScreen) {
  trackMoengageEvent("Deposit Status", {
    Status: "failed",
    orderId: "",
    Timedeposit: new Date(),
    method: "cashfree",
    Amount: amount,
  });
  var status = {
    isShow: true,
    status: false,
    amount: amount,
  };
  if (!isMobile()) {
    setEnableStatusScreen({paymentStatus: status});
  } else {
    navigation.push("WalletStack", {
      screen: "WalletStatus",
      params: {paymentStatus: status},
    });
  }
}

export function failureFunctionApp(error, amount, navigation) {
  var status = {
    isShow: true,
    status: false,
    amount: amount,
    msg:
      error?.code === "action_cancelled"
        ? "Request cancelled. Your request for adding funds was incomplete."
        : "",
  };
  navigation.push("WalletStack", {
    screen: "WalletStatus",
    params: {paymentStatus: status},
  });
}
